import styled from 'styled-components';

const CampusBlockWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5em;
  min-height: 60px;
  box-sizing: border-box;
  svg {
    min-width: 24px;
    min-height: 24px;
  }
  p {
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: border-box;
    padding-left: 0.8em;
  }
  .campus-address {
    font-size: .9em;
    color: ${p => p.theme.color.label};
  }
`;

export default {
  CampusBlockWrapper
};